import { LinearProgress, Stack } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { uniqueId } from "lodash";

import { insuranceInformationColumns } from "./cols";
import { styles } from "./DataGrid.styles";
import { Insurance } from "../../../models/Customer";
import CustomPagination from "../../atoms/CustomPagination";
import EmptyState from "../../atoms/EmptyState";

interface InsuranceInformationDataGridProps {
  data?: Insurance;
  loading?: boolean;
  onPageChange: (page: number) => void;
}

const InsuranceInformationDataGrid = ({
  data,
  loading,
  onPageChange,
}: InsuranceInformationDataGridProps) => {
  return (
    <Stack height={666}>
      <DataGrid
        columnHeaderHeight={52}
        rowHeight={56}
        loading={loading}
        data-testid="insurance-information-table"
        sx={styles.table}
        isRowSelectable={() => false}
        rows={data?.insuranceInfo || []}
        columns={insuranceInformationColumns}
        getRowId={() => uniqueId()}
        slots={{
          pagination: CustomPagination,
          loadingOverlay: LinearProgress,
          noRowsOverlay: EmptyState,
        }}
        slotProps={{
          pagination: {
            count: data?.pagination?.totalPages,
            page: (data?.pagination?.currentPage ?? 1) - 1,
            onPageChange: (_, page) => {
              onPageChange(page + 1);
            },
          },
        }}
      />
    </Stack>
  );
};

export default InsuranceInformationDataGrid;
